import React, {useCallback, useRef, useState} from 'react';
import {useForm} from 'react-final-form';
import {formatPrice} from '../../helpers/PriceHelper';
import Tooltip from './Tooltip';

export default function ServicesGrid({services, hasError}) {
    const form = useForm();
    const selected = form.getState().values.services || [];
    if (!services || Object.keys(services).length === 0) return null;
    const [bouncingKey, setBouncingKey] = useState(null);
    const [flashingKey, setFlashingKey] = useState(null);
    const [hoveredKey, setHoveredKey] = useState(null);
    const bounceTimer = useRef(null);
    const flashTimer = useRef(null);

    const toggle = useCallback((key, e) => {
        if (e.target.closest('.resume-tip')) return;

        const next = selected.includes(key)
            ? selected.filter(k => k !== key)
            : [...selected, key];

        // Trigger checkbox bounce
        setBouncingKey(key);
        if (bounceTimer.current) clearTimeout(bounceTimer.current);
        bounceTimer.current = setTimeout(() => setBouncingKey(null), 300);

        // Trigger price flash
        setFlashingKey(key);
        if (flashTimer.current) clearTimeout(flashTimer.current);
        flashTimer.current = setTimeout(() => setFlashingKey(null), 400);

        form.change('services', next);
    }, [selected, form]);

    return <div className="resume-form__services resume-select-grid">
        {Object.entries(services).map(([key, svc], index) => {
            const isSelected = selected.includes(key);

            return (
                <div
                    key={key}
                    className={`resume-select-grid__row ${hoveredKey === key && !isSelected ? 'hovered-row' : ''} ${hasError ? 'resume-select-grid__row--error' : ''}`}
                    onClick={e => toggle(key, e)}
                    onMouseEnter={() => setHoveredKey(key)}
                    onMouseLeave={() => setHoveredKey(null)}
                >
                    <div className={`resume-checkbox-field ${isSelected ? 'checked' : ''} ${bouncingKey === key ? 'checkbox-bounce' : ''}`}>
                        <label className="fa fa-check-square"></label>
                        <label className="fa fa-square-o"></label>
                    </div>
                    <div className="resume-select-grid__content">
                        {svc.name}
                    </div>
                    {svc.tooltip && (
                        <div className="resume-select-grid__info">
                            <Tooltip text={svc.tooltip} />
                        </div>
                    )}
                    <div className={`resume-select-grid__price price-row ${isSelected ? 'checked' : ''} ${flashingKey === key ? 'price-flash' : ''}`}>
                        {formatPrice(svc.price)}
                    </div>
                </div>
            );
        })}
    </div>;
}
